import { Badge } from "@/components/ui/badge";
import { Icon, type IconName } from "@/components/ui/icon-picker";
import type { PublicTask } from "@/services/public-view.service";

export function TaskTypeChip({ type }: { type: PublicTask["task_type"] }) {
	if (!type) return null;
	return (
		<span
			className="inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-medium"
			style={{ background: `${type.color}1a`, color: type.color }}
		>
			<Icon name={type.icon as IconName} className="h-3 w-3" />
			{type.name}
		</span>
	);
}

export function PriorityBadge({
	priority,
	className,
}: {
	priority: PublicTask["priority"];
	className?: string;
}) {
	return (
		<Badge variant={priority} className={className}>
			{priority.charAt(0).toUpperCase() + priority.slice(1)}
		</Badge>
	);
}
